var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('div'),_c('dialog-page'),_c('v-banner',{staticClass:"my-5",attrs:{"single-line":""}}),_c('sample-table-page'),_c('v-banner',{staticClass:"my-5",attrs:{"single-line":""}}),_c('h2',[_vm._v("Validate Form")]),_c('validate-form-page')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }